const diff_weeks = (date: number): number => {
    return Math.floor(date / (7 * 24 * 60 * 60 * 1000));
};

/**
 * Gives weeks or days since date given.
 * Days if less than one week.
 * @param str is date as a string, eg: "2020-09-07"
 */
export const getTimeSince = (str: string): string => {
    const date = new Date(str);
    const dateDiff = Date.now() - new Date(date).getTime();
    const weekDiff = diff_weeks(dateDiff);

    if (weekDiff === 1) return `${weekDiff.toString()} uke siden`;
    if (weekDiff > 1) return `${weekDiff.toString()} uker siden`;
    const days = Math.floor(dateDiff / (1000 * 3600 * 24)).toString();
    return `${days} dager siden`;
};

/**
 * Return true of date is older than 24hr from now.
 * @param ts a number of time in epoch.
 */
export const olderThan24hrAgo = (ts: number): boolean => {
    const oneDay = 60 * 60 * 24 * 1000;
    const oneDayAgo = Date.now() - oneDay;
    return ts < oneDayAgo;
};

/**
 * Returns a string with max 40 chars and "..." after for given string
 * @param str
 */
export const truncateString = (str: string): string => {
    if (!str) return;
    return str.length > 60 ? `${str.substring(0, 60)}...` : str;
};
